import React, { useContext } from 'react';
import { useStyles, StyledAvatar } from './style';
import { Typography } from '@material-ui/core';
import { ExchangesPageContext } from 'page/exchangeReport/index';

export const TypeUserStatus = ({ cor = '', titleStatus = '' }) => {
  const classes = useStyles();

  const { details } = useContext(ExchangesPageContext);

  return (
    <div>
      <StyledAvatar src={details?.user?.image || ''} color={cor} />
      <div className={classes.legenda}>
        <div
          className={classes.bola}
          style={{ backgroundColor: cor, borderColor: cor }}
        />
        <Typography
          style={{
            marginLeft: 10,
          }}
        >
          {titleStatus}
        </Typography>
      </div>
    </div>
  );
};
